import StatusBadge from '../../../core/components/StatusBadge';

export default function OrgStatusBadge({ status, statusLabel, verificationStatus, verificationStatusLabel }) {
  if (verificationStatus) {
    return <StatusBadge status={verificationStatus} label={verificationStatusLabel} />;
  }
  return <StatusBadge status={status} label={statusLabel} />;
}
